export default __webpack_public_path__ + "static/media/icon-pencil-hover.e92b3dd1.svg";